/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA large text`)
};

const es_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto grande`)
};

const de_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA großer Text`)
};

const nl_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA grote tekst`)
};

const fr_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA grand texte`)
};

const it_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA testo grande`)
};

const pt_br2_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto grande`)
};

const pt_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA texto grande`)
};

const ja_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA 大きいテキスト`)
};

const zh_cc_aaa_large = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAA 级 · 大号文字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_aaa_large = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_aaa_large(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_aaa_large", locale)
	if (locale === "en") return en_cc_aaa_large(inputs)
	if (locale === "es") return es_cc_aaa_large(inputs)
	if (locale === "de") return de_cc_aaa_large(inputs)
	if (locale === "nl") return nl_cc_aaa_large(inputs)
	if (locale === "fr") return fr_cc_aaa_large(inputs)
	if (locale === "it") return it_cc_aaa_large(inputs)
	if (locale === "pt-BR") return pt_br2_cc_aaa_large(inputs)
	if (locale === "pt") return pt_cc_aaa_large(inputs)
	if (locale === "ja") return ja_cc_aaa_large(inputs)
	return zh_cc_aaa_large(inputs)
};